import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Load all controllers defined in the import map under controllers/**/*_controller

export { application };
